<template>
  <div class="big-box">
    <div class="scroll-box">
      <div>
        <div class="big-box-img"></div>
        <div class="big-body">
          <img :src="tapTopUrl" alt="" class="tap-top" />

          <el-image
            v-if="selectPrize.logo"
            class="elImg"
            :src="selectPrize.logo"
            fit="contain"
            style="
              width: 260px;
              height: 260px;
              background: #d9d9d9;
              border-radius: 4px;
              margin-top: 14px;
            "
          >
          </el-image>
          <div v-else style="width: 260px; height: 260px; background: #d9d9d9; border-radius: 4px; margin-top: 14px;"></div>

          <div
            style="
              width: 260px;
              margin: 9px 0;
              background-size: contain;
              border-radius: 9px;
            "
            :style="{ backgroundImage: `url(${prizeInfoBg})` }"
          >
            <div
              style="
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                padding: 9px 12px 9px 12px;
              "
            >
              <span style="font-size: 10px">活动距开始</span>
              <div class="flexc-cen-x time-box">
                <span
                  class="time-item mlr2"
                  :style="{
                    'background-color': `rgba(${ruleForm.valueWordColor}, 0.08)`,
                  }"
                  >30</span
                >
                天
                <span
                  class="time-item mlr2"
                  :style="{
                    'background-color': `rgba(${ruleForm.valueWordColor}, 0.08)`,
                  }"
                  >12</span
                >
                :
                <span
                  class="time-item mlr2"
                  :style="{
                    'background-color': `rgba(${ruleForm.valueWordColor}, 0.08)`,
                  }"
                  >12</span
                >
                :
                <span
                  class="time-item mlr2"
                  :style="{
                    'background-color': `rgba(${ruleForm.valueWordColor}, 0.08)`,
                  }"
                  >12</span
                >
              </div>
            </div>
            <div style="padding: 12px; background: #ffffff; border-radius: 9px">
              <div style="color: #333333; font-size: 11px">
                {{ selectPrize.title }}
              </div>
              <div style="color: #666666; font-size: 10px; margin-top: 11px">
                竞拍门票0积分，加价幅度50积分
              </div>
              <div
                style="
                  display: flex;
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  margin-top: 11px;
                "
              >
                <div style="font-size: 9px; color: #999999">
                  起拍价
                  <span
                    :style="{ color: `${ruleForm.pointTextColor}` }"
                    style="font-size: 16px; font-weight: bold"
                    >3000</span
                  >
                  积分
                </div>
                <div
                  style="
                    font-size: 11px;
                    padding: 5px 6px;
                    color: #b99846;
                    border-radius: 19px;
                    background: #fef3d7;
                    display: flex;
                    justify-content: center;
                    flex-direction: row;
                    align-items: center;
                    line-height: 11px;
                  "
                >
                  <img
                    :src="tipIcon"
                    alt=""
                    style="width: 11px; height: 11px; margin-right: 2px"
                  />
                  <div>竞拍规则</div>
                </div>
              </div>
            </div>
          </div>

          <div
            v-if="
              ruleForm.auctionItemImageUrls &&
              ruleForm.auctionItemImageUrls.length > 0
            "
            style="
              width: 260px;
              border-radius: 9px;
              padding: 15px 6px;
              background: #ffffff;
              border-radius: 9px;
            "
          >
            <div style="padding: 0 0 12px 6px">拍品详情</div>
            <img
              v-for="(item, index) in ruleForm.auctionItemImageUrls"
              :key="index"
              :src="item"
              alt=""
              style="width: 100%; height: auto; border-radius: 6px"
            />
          </div>

          <div
            class="main-button"
            :style="{
              'background-image': `url(${ruleForm.buttonBackgroundColor})`,
              color: ruleForm.buttonWordColor,
            }"
          >
            立即出价
          </div>
        </div>
      </div>

      <img
        v-if="ruleForm.showMoreList == '1'"
        class="more-activity"
        :src="
          ruleForm.showMoreListUrl ||
          $globalCdn + '/images/preview/more_activity.png'
        "
        alt=""
      />
    </div>
    <div class="title" v-if="!oneShow">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
const $globalCdn = "https://cdn-image.yucrm.cn/images/dyAssets"
export default {
  name: "",
  components: {},
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    oneShow: {
      type: Boolean,
      default: false,
    },
    baseUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tapTopUrl: $globalCdn + "/images/preview/shop_top.png",
      tipIcon: this.baseUrl + "tip_icon.png",
      prizeInfoBg: this.baseUrl + "prize_info_bg.png",

      current: 0,
    };
  },
  computed: {
    selectPrize() {
      if (this.ruleForm.tableData && this.ruleForm.tableData.length > 0) {
        return this.ruleForm.tableData[0];
      }
      return {
        logo: null,
      };
    },
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 1;
  background-color: #ffffff;
  // overflow: auto;
  // 隐藏滚动条

  .scroll-box {
    overflow: auto;
    height: 560px;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      width: 0 !important;
    }
    -ms-overflow-style: none;
    border-radius: 24px;
    background: linear-gradient(180deg, #ffffff 0%, #f7f7f7 100%);
    border: 1px solid #f7f7f7;
  }

  // overflow: hidden;
  .big-box-img {
    border-radius: 24px;
    width: 283px;
    height: 790px;
    // background-repeat: no-repeat;
    // background-size: 100%;
  }
  .big-body {
    // position: absolute;
    // top: 0;
    // left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // overflow: hidden;
    margin-top: -795px;

    .btn-box {
      width: 177px;
      height: 34px;
      position: relative;
      // position: absolute;
      // top: 480px;

      .btn-box-text {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 12px;
        font-weight: bold;
      }
    }

    .tap-top {
      margin-top: 8px;
    }
    .theme {
      font-weight: 600;
      font-size: 20px;
      margin-top: 14px;
      text-transform: none;
      width: 100%;
      padding-left: 25px;
    }
    .desc {
      margin: 10px auto;
      // width: 170px;
      height: 10px;
      font-weight: 400;
      font-size: 11px;
      // text-align: center;
      line-height: 10px;
      font-style: normal;
      text-transform: none;
      width: 100%;
      padding-left: 25px;
    }

    .time-box {
      font-size: 8px;
      .time-item {
        background: linear-gradient(25deg, #6b5841 0%, #2e271e 100%);
        display: flex;
        justify-content: center;
        align-items: center;
        width: 13px;
        height: 13px;
        border-radius: 2px;
        color: #ffffff;
      }
    }
  }
  .more-activity {
    position: absolute;
    width: 60px;
    height: 60px;
    bottom: 125px;
    right: 6px;
  }
  .title {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
}
.main-button {
  width: 219px;
  height: 33px;
  font-size: 12px;
  background-size: 100% 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-bottom: 13px;
  font-weight: bold;
  position: absolute;
  bottom: 27px;
}
.mlr2 {
  margin: 0 2px;
}

.prize-box {
  padding: 6px;
  margin-top: 16px;
  display: flex;
  flex-direction: row;

  &-item {
    padding: 0 12px;
    display: flex;
    flex-direction: row;
    border-radius: 0 0 6px 6px;
  }
}
.elImg {
  border: 1px solid #ddd;
}
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: #f5f7fa;
  color: #909399;
  font-size: 12px;
}
</style>
